<template>
  <div class="tw-flex tw-gap-3">
    <div class="tw-text-sm tw-my-auto" v-if="displayFilterItems.length > 0">Filters:</div>
    <base-badge v-for="item in displayFilterItems" :key="item" color="gray" class="tw-bg-gray-300">{{ item }}</base-badge>
  </div>
</template>

<script>
export default {
  name: "FilterDisplay",
  props: { filters: Object },
  computed: {
    displayFilterItems() {
      let list = [];

      //dates
      if (this.filters.startDate != null && this.filters.endDate != null) {
        if (this.datesAreOnSameDay(this.filters.startDate, this.filters.endDate)) {
          list.push(this.filters.startDate.toLocaleDateString());
        } else list.push(this.filters.startDate.toLocaleDateString() + " - " + this.filters.endDate.toLocaleDateString());
      } else if (this.filters.startDate != null) list.push(this.filters.startDate.toLocaleDateString());
      else if (this.filters.endDate != null) list.push(this.filters.endDate.toLocaleDateString());

      //locations
      if (this.filters.locationsFilter && this.filters.locationsFilter.length > 0) {
        for (let i = 0; i < this.filters.locationsFilter.length; i++) {
          list.push(this.filters.locationsFilter[i].name);
        }
      }

      //prescription status
      if (this.filters.prescriptionStatusFilter && this.filters.prescriptionStatusFilter.length > 0) {
        for (let i = 0; i < this.filters.prescriptionStatusFilter.length; i++) {
          list.push("Status: " + this.filters.prescriptionStatusFilter[i]);
        }
      }

      //program group
      if (this.filters.programGroupsFilter && this.filters.programGroupsFilter.length > 0) {
        for (let i = 0; i < this.filters.programGroupsFilter.length; i++) {
          list.push("Group: " + this.filters.programGroupsFilter[i]);
        }
      }

      //program
      if (this.filters.programsFilter && this.filters.programsFilter.length > 0) {
        for (let i = 0; i < this.filters.programsFilter.length; i++) {
          list.push("Program: " + this.filters.programsFilter[i].name);
        }
      }

      //plan status
      if (this.filters.planStatusFilter && this.filters.planStatusFilter.length > 0) {
        for (let i = 0; i < this.filters.planStatusFilter.length; i++) {
          list.push("Status: " + this.filters.planStatusFilter[i]);
        }
      }

      //plan group
      if (this.filters.planGroupsFilter && this.filters.planGroupsFilter.length > 0) {
        for (let i = 0; i < this.filters.planGroupsFilter.length; i++) {
          list.push("Group: " + this.filters.planGroupsFilter[i]);
        }
      }

      //plan
      if (this.filters.plansFilter && this.filters.plansFilter.length > 0) {
        for (let i = 0; i < this.filters.plansFilter.length; i++) {
          list.push("Program: " + this.filters.plansFilter[i].name);
        }
      }

      return list;
    },
  },
  methods: {
    datesAreOnSameDay(first, second) {
      return first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();
    },
  },
};
</script>
